 export const goTo:{[key:string]:string} ={
    'Health Block /Sub Division':'/healthblock',
    'Zone/Division/Circle':'/zone',
    'VHND/UHND Outreach':'/VHND',
    'All Users':'/user-management',
    'Roles':'/user-management/role',
    'Analytics':'/user-management/analytics',
 }